import { Parallel } from 'services/api';
import { SHIFT } from 'shared/api';
import { getShiftTextRepresentation } from 'shared/utils';
import type { AppSelectOption } from 'shared/UI/UIKit/Select';

export const educationParallels: AppSelectOption[] = Object.values(Parallel).map((value) => {
  let label: React.ReactNode = value;
  switch (value) {
    case Parallel.FIRST:
      label = '1';
      break;

    case Parallel.SECOND:
      label = '2';
      break;

    case Parallel.THIRD:
      label = '3';
      break;

    case Parallel.FOURTH:
      label = '4';
      break;

    case Parallel.FIFTH:
      label = '5';
      break;

    case Parallel.SIXTH:
      label = '6';
      break;

    case Parallel.SEVENTH:
      label = '7';
      break;

    case Parallel.EIGHTH:
      label = '8';
      break;

    case Parallel.NINTH:
      label = '9';
      break;

    case Parallel.TENTH:
      label = '10';
      break;

    case Parallel.ELEVENTH:
      label = '11';
      break;

    default:
      label = value;
      break;
  }

  return { label, value };
});

export const educationIncludeSaturdayOptions: AppSelectOption[] = [
  { label: 'Да', value: 'true' },
  { label: 'Нет', value: 'false' },
];

export const educationShifts: AppSelectOption[] = Object.values(SHIFT).map((value) => {
  let label: React.ReactNode = value;
  switch (value) {
    case SHIFT.MORNING:
      label = getShiftTextRepresentation(SHIFT.MORNING);
      break;

    case SHIFT.AFTERNOON:
      label = getShiftTextRepresentation(SHIFT.AFTERNOON);
      break;

    default:
      label = value;
      break;
  }

  return { label, value };
});

export const educationParallelTextRepresentation: Record<Parallel, string> = {
  [Parallel.FIRST]: '1',
  [Parallel.SECOND]: '2',
  [Parallel.THIRD]: '3',
  [Parallel.FOURTH]: '4',
  [Parallel.FIFTH]: '5',
  [Parallel.SIXTH]: '6',
  [Parallel.SEVENTH]: '7',
  [Parallel.EIGHTH]: '8',
  [Parallel.NINTH]: '9',
  [Parallel.TENTH]: '10',
  [Parallel.ELEVENTH]: '11',
};
